import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EaccessAuthService } from '../../auth/eaccess-auth.service';
import { NGXLogger } from 'ngx-logger';
import { ROLE_AUDIT_TRAIL_USER_ACTIONS_READ } from '../../shared/constants';
import { map } from 'rxjs';

export const auditTrailUserActionsGuard: CanActivateFn = (route, state) => {
  const authService = inject(EaccessAuthService);
  const router = inject(Router);
  const logger = inject(NGXLogger);

  return authService.hasRole$(ROLE_AUDIT_TRAIL_USER_ACTIONS_READ).pipe(
    map((hasRole) => {
      if (hasRole) {
        logger.log('User is authorized to view user actions audit trail.');
        return true;
      } else {
        logger.log('User is not authorized to view user actions audit trail. Redirecting to landing page.');

        const path = state.url.split('?')[0];
        const queryParams = router.parseUrl(state.url.replace(path, '')).queryParams;

        const url = router.parseUrl(`/?origin=${path}`);

        for (const kvp of Object.entries(queryParams)) {
          if (kvp[0] !== 'origin') {
            url.queryParams[kvp[0]] = kvp[1];
          }
        }

        return url;
      }
    })
  );
};
